module.exports = "https://www.niulinkcloud.cn/_next/static/media/pcBanner3.0a5b14cf5935f1896d8cd83d6f8a4719.jpg";